import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { ComponentsModule } from '@client/app/components/components.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { DomainDashboardNotificationsComponent } from './blocks/notifications/domain-dashboard-notifications.component';
import { CaptextComponent } from './captext/captext.component';
import { DomainDashboardAccessibilityComponent } from './charts/accessibility/domain-dashboard-accessibility.component';
import { DomainDashboardHeartbeatComponent } from './charts/heartbeat/domain-dashboard-heartbeat.component';
import { DomainDashboardHistoryComponent } from './charts/history/domain-dashboard-history.component';
import { DomainDashboardPoliciesComponent } from './charts/policies/domain-dashboard-policies.component';
import { DomainDashboardQaComponent } from './charts/qa/domain-dashboard-qa.component';
import { DomainDashboardSeoComponent } from './charts/seo/domain-dashboard-seo.component';
import { DomainDashboardStatisticsComponent } from './charts/statistics/domain-dashboard-statistics.component';
import { DomainDashboardComponent } from './dashboard.component';
import { ActiveFeaturePipe } from '@monsido/core/pipes/active-feature/active-feature.pipe';
import { UIRouterModule } from '@uirouter/angular';
import { LayoutModule } from '@monsido/angular-shared-components';
import { DoughnutComponent } from '@client/app/modules/charts/components/doughnut.component';
import { BarlineComponent } from '@client/app/modules/charts/components/barline.component';
import { ModalsDirectivesModule } from '@client/app/modules/modals/directives/modals-directives.module';
import { LineComponent } from '@client/app/modules/charts/components/line.component';
import { NgbTooltipMfeModule } from '@client/mfe/overlay/ngb-tooltip-mfe.module';

@NgModule({
    schemas: [NO_ERRORS_SCHEMA],
    imports: [
        CommonModule,
        ComponentsModule,
        UpgradePipeModule,
        TranslateModule,
        ActiveFeaturePipe,
        UIRouterModule,
        LayoutModule,
        DoughnutComponent,
        NgbTooltipMfeModule,
        BarlineComponent,
        ModalsDirectivesModule,
        LineComponent,
    ],
    declarations: [
        DomainDashboardNotificationsComponent,
        CaptextComponent,
        DomainDashboardAccessibilityComponent,
        DomainDashboardHeartbeatComponent,
        DomainDashboardHistoryComponent,
        DomainDashboardPoliciesComponent,
        DomainDashboardQaComponent,
        DomainDashboardSeoComponent,
        DomainDashboardStatisticsComponent,
        DomainDashboardComponent,
    ],
    exports: [
        DomainDashboardNotificationsComponent,
        CaptextComponent,
        DomainDashboardAccessibilityComponent,
        DomainDashboardHeartbeatComponent,
        DomainDashboardHistoryComponent,
        DomainDashboardPoliciesComponent,
        DomainDashboardQaComponent,
        DomainDashboardSeoComponent,
        DomainDashboardStatisticsComponent,
        DomainDashboardComponent,
    ],
})
export class UpgradeDomainModule {}
